(function () {
    'use strict';

    angular
        .module('app.commonPages')
        .factory('commonPagesService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getCommonPages(params, loader) {
                    var url_getCommonPages = $rootScope.apiUrl + 'admin/getCommonPages';
                    return handleRequest(url_getCommonPages, 'POST', params, loader);
                }

                function getCommonPagesSetting(loader) {
                    var url_getCommonPagesSetting = $rootScope.apiUrl + 'admin/getCommonPagesSetting';
                    return handleRequest(url_getCommonPagesSetting, 'GET', null, loader);
                }

                function getAllProjectByAdvertiserID(id, loader) {
                    var url = $rootScope.apiUrl + 'common/getAllProjectByAdvertiserID/' + id;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getInfluencerGroupByAdvertiserID(id, loader) {
                    var url = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupListSideBarMenu?selected_company_id='+ id;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getCampaignsByAdvertiserID(id, loader) {
                    var url = $rootScope.apiUrl + 'campaign/getCampaignsForSideBarMenu/'+ id;
                    return handleRequest(url, 'GET', null, loader);
                }

                service.getCommonPages = getCommonPages;
                service.getCommonPagesSetting = getCommonPagesSetting;
                service.getAllProjectByAdvertiserID = getAllProjectByAdvertiserID;
                service.getInfluencerGroupByAdvertiserID = getInfluencerGroupByAdvertiserID;
                service.getCampaignsByAdvertiserID = getCampaignsByAdvertiserID;

                return service;
            }
        ]);
})();
